<template>
    <!--个人资料-->
    <div class="mysection">
        <div class="inputs_profile">
          <el-form ref="form" :model="form" :rules="userRules">
            <el-row>
                <el-col :span="24">
                  <el-form-item label="昵称:" prop="username" labelWidth="110px">
                    <el-input v-model="form.username" placeholder="请输入昵称"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="性别:" prop="sex" labelWidth="110px">
                    <el-radio-group v-model="form.sex" class="el-input">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="年龄:" prop="age" labelWidth="110px">
                    <el-input v-model="form.age" placeholder="请输入年龄"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="学历:" prop="education" labelWidth="110px">
                    <el-select v-model="form.education" placeholder="请选择">
                        <el-option
                                v-for="item in dictionarys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row :gutter="4">-->
                <!--<el-col :span="8">手机号</el-col>-->
                <!--<el-col :span="16">-->
                    <!--<el-input v-model="form.phoneNumber" placeholder="请输入手机号"></el-input>-->
                <!--</el-col>-->
            <!--</el-row>-->
            <el-row>
                <el-col :span="24">
                  <el-form-item label="邮箱:" prop="email" labelWidth="110px">
                    <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="btn_large">
            <el-button type="primary" size="large" @click="getUserInFoEdit">确定</el-button>
        </div>

    </div>
</template>
<script>
    import {reqGetDictionaryListByCode} from '../../api/weixin-api';
    import {reqWebUserOneById} from "../../api/weixin-api"
    import {reqWxWebUserEdit} from "../../api/weixin-api"
    export default {
        data(){
            return{
                dictionarys:[],
                form:{
                    id:'',
                    username:'',
                    sex:'1',
                    age:'',
                    education:'',
                    phoneNumber:'',
                    email:'',
                },
                userRules: {
                  username: [
                    {required: true, message: '请输入昵称', trigger: 'blur'},
                    {min: 1, max: 15, message: '昵称不能超过15个字符 ', trigger: 'blur'},
                    {pattern: /^[^ ]+[\s\S]*[^ ]+$/, message:'昵称前后不能有空格',trigger: 'blur'},
                  ],
                    sex: [
                        {required: true, trigger: 'change'},
                    ],
                    age: [
                      {required: true,label:'年龄', message: '请输入年龄', trigger: 'blur'},
                      {pattern: /^\d{2}$/,  message:'年龄只能是2个字符',trigger: 'blur'},
                    ],
                    education: [
                        {required: true, message: '请选择学历'}
                    ],
                    phoneNumber: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^1[3|4|5|7|8|9][0-9]{9}$/, message:'请输入正确的手机号',trigger: 'blur'},
                    ],
                    email : [
                        {message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
                    ],
                },
            }
        },
        methods:{
            getUserInFo(id){
                this.form.id =id;
                reqWebUserOneById({id: this.form.id}).then((res) => {
                    if (res.data.code === 1) {
                        this.form.username = res.data.data.username;
                        this.form.sex = res.data.data.sex;
                        this.form.age = res.data.data.age;
                        this.form.education = res.data.data.education;
                        this.form.phoneNumber = res.data.data.phoneNumber;
                        this.form.email = res.data.data.email;
                    }
                });
            },
            getDictionarysEducation:function () {
                var that=this;
                let para={code:'education'};
                reqGetDictionaryListByCode(para).then((res)=>{
                    this.dictionarys=res.data.data;
                    this.dictionarys.forEach(function (obj,i) {
                        if(that.form.education==obj.id){
                            that.form.education=obj.name;
                        }
                    })
                })
            },
            //修改个人资料
            getUserInFoEdit(){
                var that=this;
              this.$refs.form.validate((valid) => {
                if (valid) {
                  let param = Object.assign({}, this.form);
                  reqWxWebUserEdit(param).then((res) => {
                    if (res.data.code === 1) {
                      that.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                      that.$router.push('/wxMyHomePage');
                    }else if(res.data.code===2){
                      localStorage.setItem('Authorization', res.data.data.token);
                      that.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                      that.$router.push('/wxMyHomePage');
                    }else if(res.data.code=== 3){
                      that.$message({
                        message: '抱歉，该昵称已存在',
                        type: 'error'
                      });
                      this.form.username='';
                    }else {
                      that.$message({
                        message: res.data.msg,
                        type: 'error'
                      })
                    }
                  })
                }
              })
            },

          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          backWeiXin:function() {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxMyHomePage';
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          }

        },
        mounted(){
            this.$store.dispatch('hideHF');
            var id=this.$route.query.id;
            if(id){
              this.getUserInFo(id);
            }
            this.getDictionarysEducation();
            this.isWechatBrowser();
            this.backWeiXin()
        }
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxUserInfo.vue